/**
 * [INPUT]: 无运行时依赖
 * [OUTPUT]: 对外提供 SITE 常量、RouteSeo 类型、ROUTE_SEO 映射与 absoluteUrl 助手
 * [POS]: apps/web/seo 的站点 SEO 真源（canonical 域、默认 meta、按路由 meta）
 * [PROTOCOL]: 变更时更新本头部，然后检查 ../CLAUDE.md
 */

/** Canonical production origin (HTTPS apex). */
export const SITE_ORIGIN = 'https://pslanalyzer.com'

export const SITE = {
  origin: SITE_ORIGIN,
  name: 'PSL Analyzer',
  defaultTitle:
    'PSL Scale Test — Free AI PSL Score & Rating (No Upload)',
  defaultDescription:
    'Test your PSL Scale score free with on-device AI — no photo upload, full privacy. Get facial analysis and your PSL rating (0–8) in seconds.',
  ogImagePath: '/og-image.png',
  locale: 'en_US',
  twitterCard: 'summary_large_image' as const,
  contactEmail: 'contact@pslanalyzer.com',
} as const

export interface RouteSeo {
  title: string
  description: string
  /** Path beginning with `/`, used for canonical + og:url */
  path: string
  /** When true, emit robots noindex,follow */
  noindex?: boolean
}

export const ROUTE_SEO = {
  home: {
    path: '/',
    title: SITE.defaultTitle,
    description: SITE.defaultDescription,
  },
  contact: {
    path: '/contact',
    title: 'Contact | PSL Analyzer',
    description:
      'Contact the PSL Analyzer team about scoring methodology, privacy architecture, product feedback, or collaboration.',
  },
  terms: {
    path: '/terms',
    title: 'Terms of Service | PSL Analyzer',
    description:
      'Terms of service for PSL Analyzer — a heuristic, on-device facial proportion scoring tool for entertainment and educational reference only.',
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy | PSL Analyzer',
    description:
      'Privacy policy for PSL Analyzer. Facial scoring runs on-device; original photos are never uploaded. Optional AI diagnosis sends only anonymized metrics.',
  },
  notFound: {
    path: '/404',
    title: 'Page Not Found | PSL Analyzer',
    description: 'The page you requested could not be found on PSL Analyzer.',
    noindex: true,
  },
} as const satisfies Record<string, RouteSeo>

export function absoluteUrl(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (normalized === '/') return `${SITE_ORIGIN}/`
  return `${SITE_ORIGIN}${normalized}`
}
